import { OptionType } from '@medely/ui-kit';
import { gateNames } from '@mp/constants';
import { useGate } from '@mp/hooks';
import {
  getMissingSpecialtiesOptions,
  hasMatchingSpecialtiesForHighRiskJob,
  JobPositionsProps,
  JobSpecialtiesProps,
  MissingHighRiskSpecialtiesProps,
} from '@mp/utils';

type UseRecommendedSpecialtiesDataParams = {
  jobPositions?: JobPositionsProps[] | null;
  jobSpecialties?: JobSpecialtiesProps[] | null;
  jobMissingHighRiskSpecialties?: MissingHighRiskSpecialtiesProps[] | null;
  userSpecialties?: JobSpecialtiesProps[] | null;
};

export const useRecommendedSpecialtiesData = ({
  jobPositions,
  jobSpecialties,
  userSpecialties,
  jobMissingHighRiskSpecialties,
}: UseRecommendedSpecialtiesDataParams) => {
  const showSpecialtySpeedbumExtension = useGate(gateNames.specialty_speedbump_extension);

  const allSpecialtiesInformation = jobMissingHighRiskSpecialties || [];
  const hasAllSpecialtiesInformation = allSpecialtiesInformation.length > 0;
  const hasLegacyAllSpecialtiesInformation = hasMatchingSpecialtiesForHighRiskJob({
    jobPositions,
    jobSpecialties,
    userSpecialties,
  });

  const specialtyOptions = showSpecialtySpeedbumExtension
    ? (jobMissingHighRiskSpecialties as OptionType[])
    : getMissingSpecialtiesOptions({
        jobSpecialties,
        userSpecialties,
      });

  return {
    hasAllSpecialtiesInformation: showSpecialtySpeedbumExtension
      ? hasAllSpecialtiesInformation
      : hasLegacyAllSpecialtiesInformation,
    specialtyOptions,
  };
};
